import { Theme } from './theme';

export function getTextAreaStyles(theme: Theme) {
	const { width, padding, fontSize } = theme.textArea.size.auto;
	const css = {
		textArea: {
			width: width,
			padding: padding,
			fontSize: fontSize,
			border: theme.textArea.textAreaBorder.border,
			borderRadius: theme.textArea.textAreaBorder.borderRadius,
			boxShadow: theme.textArea.textAreaShadow,
			backgroundColor: theme.textArea.backgroundColor
		},
		textAreaFocused: {
			border: theme.textArea.focused.border,
			boxShadow: theme.textArea.focused.boxShadow
		},
		textAreaDisabled: {
			background: theme.textArea.disabled.background,
			color: theme.textArea.disabled.color
		},
		textAreaError: {
			border: theme.textArea.error.border
		},
		textAreaErrorFocused: {
			boxShadow: theme.textArea.errorFocused.boxShadow
		}
	};

	return css;
}
